module.exports = __webpack_public_path__ + "static/images/recommend-title-bg.40bb2f3.png";